import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Textarea,
  useDisclosure,
  Button,
  Select,
  Flex,
  useToast,
} from '@chakra-ui/react';
import FaqApi from 'api/faq';
import PermissionGroupApi from 'api/permissiongroup';
import UserApi from 'api/user';

export default function PopModal(props) {
  const adminUserId = props?.adminUserId;

  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [list, setList] = useState([]);
  const [listTotal, setListTotal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [permissionGroupId, setPermissionGroupId] = useState(null);

  const CloseModal = () => {
    setPermissionGroupId(null);
    onClose();
  };

  const fetchList = async () => {
    try {
      setLoading(true);
      let response = await PermissionGroupApi.List({
        sort: 'name:asc',
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchList();
  }, []);

  const AddGroup = async (e) => {
    e.preventDefault();
    console.log(permissionGroupId);
    try {
      let response = await UserApi.AddPermissionGroupToUser({
        adminUserId,
        permissionGroupId,
      });
      response = response.data;
      if (response.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully Added',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        setPermissionGroupId(null);
        CloseModal();
        props.func();
      } else if (response.status_code !== 200) {
        toast({
          title: response?.message || 'Error Adding',
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
      // window.location.reload();
      // console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        onClick={onOpen}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={CloseModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {/* <FormControl>
              <FormLabel>Type</FormLabel>
              <Select
                placeholder="Select Type"
                onChange={(e) => setTags(e.target.value)}
              >
                <option value="general">General</option>
                <option value="webinar">Webinar</option>
                <option value="online course">Online Course</option>
                <option value="offline course">Offline Course</option>
                <option value="challenge">30 Days Challenge</option>
                <option value="payment">Payment</option>
              </Select>
            </FormControl> */}

            <FormControl mt={4}>
              <FormLabel>Permission Group</FormLabel>
              <Select
                placeholder='Select Permission Group'
                onChange={(e) => setPermissionGroupId(e.target.value)}>
                {list?.map((permissionGroup) => (
                  <option
                    key={permissionGroup.id}
                    value={permissionGroup.id}>
                    {permissionGroup.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              disabled={!permissionGroupId && true}
              colorScheme='blue'
              mr={3}
              onClick={AddGroup}>
              Add
            </Button>
            <Button onClick={CloseModal}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
